module.exports = __webpack_public_path__ + "img/01.7035b20a.png";